import { ReactElement } from 'react'
import { Divider, Space } from 'antd'

import BonLookSVG from 'src/modules/shared/BonLookLogoSVG'
import { SocialMediaBonLook } from 'src/modules/shared/SocialMediaLogo'

const BLOCK_NAME = 'info-section'

const InfoSection = (): ReactElement => {
  return (
    <Space direction="vertical" className={BLOCK_NAME}>
      <BonLookSVG />
      <Divider />
      <a href="tel:18777556659">1-877-755-6659</a>
      <a href="mailto:support@bonlook.com">support@bonlook.com</a>
      <SocialMediaBonLook />
    </Space>
  )
}

export default InfoSection
